module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list-m.bbe0379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list-m.png
// module id = nsDH
// module chunks = 18